<template>
    <v-card>
        <v-card-title class="justify-center text-h5">
            <strong>Productos graficos</strong>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="6">
                    <v-select
                        label="Tiempo"
                        outlined
                        dense
                        :items="itemsTimes"
                        item-text="name"
                        item-value="val"
                        v-model="filterTime"
                        @change="getData"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-select
                        label="Analizar"
                        outlined
                        dense
                        :items="itemsAnalysis"
                        item-text="name"
                        item-value="val"
                        v-model="filterAnalysis"
                        @change="getData"
                    ></v-select>
                </v-col>
                <v-col cols="12" sm="6" v-if="filterTime=='custom'">
                    <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dateInit"
                                label="Fecha inicial"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                color="orange"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dateInit"
                            @input="menu1 = false, getData()"
                            locale="es"
                            color="primary"
                            class="ma-0"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="6" v-if="filterTime=='custom'">
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dateEnd"
                                label="Fecha final"
                                prepend-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                color="orange"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dateEnd"
                            @input="menu2 = false, getData()"
                            locale="es"
                            color="primary"
                            class="ma-0"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>

            <v-divider/>

            <div class="text-h6 mb-1 mt-4 text-center">VENTAS</div>
            <line-chart2 v-if="!loading" :data="showGraph?Object.keys(this.dataResult).map(e => this.dataResult[e].total):[]" :labels="showGraph?Object.keys(this.dataResult).map(e => this.dataResult[e].name):[]" style="height: 300px" />
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            itemsTimes: [
                {val: 'day', name: 'Día actual'},
                {val: 'week', name: 'Semana actual'},
                {val: 'month', name: 'Mes actual'},
                {val: 'year', name: 'Año actual'},
                {val: 'custom', name: 'Personalizado'},
            ],
            filterTime: 'month',
            itemsAnalysis:[
                {val: 'physical', name: 'Tienda física'},
                {val: 'virtual', name: 'Tienda virtual'},
                {val: 'both', name: 'Tienda virtual + fisica'},
            ],
            filterAnalysis: 'both',
            menu1: false,
            menu2: false,
            dateInit: '',
            dateEnd: '',
            // results
            dataResult: {},
            showGraph: false
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        async getData() {
            this.loading = true
            await axios.post('/admin/get-products-results', {
                filterTime: this.filterTime,
                filterAnalysis: this.filterAnalysis,
                dateInit: this.dateInit,
                dateEnd: this.dateEnd
            })
            .then((response) => {
                // console.log(response);
                this.dataResult = response.data
                if (Object.keys(this.dataResult).length > 0) {
                    this.showGraph = true
                }
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
            .finally(() => {
                setTimeout(() => {
                    this.loading = false
                }, 100);
            })
        }
    }
}
</script>
